// An event as the site holds it (docs/SPEC.md "API contract (v1)" Event): the rules' fields (NowishEvent) plus what
// the card and lists show. `start` / `end` are parsed once, when the event arrives (parseEvent).
import type { NowishEvent } from "../shared/rules";

export interface FeedEvent extends NowishEvent {
  description?: string | null;
  venue_name?: string | null;
  address?: string | null;
  image_url?: string | null;
  source?: string | null;
  source_name?: string | null;
  source_url?: string | null;
  recurring?: boolean | null;
  scale?: "small" | "medium" | "big" | null;
  availability?: "available" | "sold_out" | "closed" | null;
  /** Only on the profile's copies of starred events (GET /profile `events`). */
  status?: string | null;
  area?: { type: "Polygon"; coordinates: number[][][] } | null;
}

/** An event as the server sends it: times as ISO strings. */
export type RawEvent = Omit<FeedEvent, "start" | "end"> & { start: string; end?: string | null };

export interface Tag { name: string; emoji?: string | null; count: number }

export function parseEvent(raw: RawEvent): FeedEvent {
  return { ...raw, start: new Date(raw.start), end: raw.end ? new Date(raw.end) : null, tags: raw.tags || [] };
}
